import { createSlice } from "@reduxjs/toolkit";

const modalSlice = createSlice({
  name: "modal",
  initialState: {
    modal: {
      type: null,
      isOpen: false,
      redirect: "",
      data: null,
      isUpdated: {
        isUpdatedIn: "",
        data: null,
      },
      subModal: {
        type: null,
        isOpen: false,
      },
    },
  },
  reducers: {
    setModal: (state, action) => {
      state.modal = {
        ...state.modal,
        type: action.payload?.type,
        isOpen: true,
        redirect: action.payload?.redirect || "",
        data: action.payload?.data || null,
      };
    },
    setSubModal: (state, action) => {
      state.modal.subModal = {
        type: action.payload?.type,
        isOpen: true,
      };
    },
    closeSubModal: (state) => {
      state.modal.subModal = {
        type: null,
        isOpen: false,
      };
    },
    closeModal: (state) => {
      state.modal = {
        type: null,
        isOpen: false,
        redirect: "",
        data: null,
        subModal: {
          type: null,
          isOpen: false,
        },
      };
    },
    closeModalWithUpdate: (state, action) => {
      state.modal = {
        type: null,
        isOpen: false,
        redirect: "",
        data: null,
        isUpdated: action.payload.isUpdated || state.modal.isUpdated,
        subModal: {
          type: null,
          isOpen: false,
        },
      };
    },
    cleanIsUpdate: (state) => {
      state.modal.isUpdated = {
        isUpdatedIn: "",
        data: null,
      };
    },
  },
});

export const {
  setModal,
  setSubModal,
  closeSubModal,
  closeModal,
  closeModalWithUpdate,
  cleanIsUpdate,
} = modalSlice.actions;

export default modalSlice.reducer;
